<div class="table-responsive">
  <div class="card">
    <div class="card-body">

      <div class="row">
        <div class="col-md-12">
          <div class="button-items mt-1" style="float: left;padding-left: 1%;">
            <h2>Time Approver Rules</h2>
          </div>
          <div class="button-items" style="float: right;">
            <button class="btn btn-primary btn-sm" (click)="loadUserData(lastTableLazyLoadEvent)"
              pTooltip="Refresh the table" appActionTooltip><i class="mdi mdi-reload"></i></button>
              <button class="btn btn-primary btn-sm" (click)="dt.clear()"
              pTooltip="Clear all column filters and sorting" appActionTooltip>Clear<i
              class="mdi mdi-filter-remove"></i></button>
            </div>
            <!-- <div class="button-items mt-3 mb-3" style="float: right;">
            <button class="btn btn-primary btn-sm"  (click)="addUser()" >Add User</button>
          </div> -->
        </div>
      </div>
      <p-table [lazy]="true" #dt [columns]="cols" (onLazyLoad)="loadUserData($event)" [value]="users" dataKey="id"
        styleClass="p-datatable-users" [rowHover]="true" [rows]="10" [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10,25,50]" [loading]="loading" responsiveLayout="scroll" [paginator]="true"
        [autoLayout]="true" [totalRecords]="totalRecords"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0"
        paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th style="width:7em;padding:1rem !important;">
              View/Edit
            </th>
            <th pSortableColumn="firstName">
              <div class="flex justify-content-between align-items-center">
                First Name
                <p-sortIcon field="firstName"></p-sortIcon>
                <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                type="text" field="firstName" display="menu"></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="lastName">
              <div class="flex justify-content-between align-items-center">
                Last Name
                <p-sortIcon field="lastName"></p-sortIcon>
                <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                type="text" field="lastName" display="menu"></p-columnFilter>
              </div>
            </th>

            <th pSortableColumn="mainEmail">
              <div class="flex justify-content-between align-items-center">
                Email
                <p-sortIcon field="mainEmail"></p-sortIcon>
                <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                type="text" field="mainEmail" display="menu"></p-columnFilter>
              </div>
            </th>


            <th pSortableColumn="timeZone">
              <div class="flex justify-content-between align-items-center">
                Time Zone
                <p-sortIcon field="timeZone"></p-sortIcon>
                <p-columnFilter matchMode="equals" [showOperator]="false" [showAddButton]="false"
                  type="text" field="timeZone" display="menu">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-dropdown [ngModel]="value" [options]="timeZones"
                      (onChange)="filter($event.value)" placeholder="Any">
                      <ng-template let-option pTemplate="item">
                        <span [class]="'customer-badge status-' + option">{{option}}</span>
                      </ng-template>
                    </p-dropdown>
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                Role
                <!-- <p-sortIcon field="role"></p-sortIcon> -->
                <!-- <p-columnFilter [showOperator]="false" [showAddButton]="false"
                type="text" field="role" display="menu"
              ></p-columnFilter> -->
            </div>
          </th>
          <th pSortableColumn="type">
            <div class="flex justify-content-between align-items-center">
              Type
              <p-sortIcon field="type"></p-sortIcon>
              <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
              type="text" field="type" display="menu"></p-columnFilter>
            </div>
          </th>
          <th>
            <div class="flex justify-content-between align-items-center">
              Approver Practice Area(s)
            </div>
          </th>
          <th >
            <div class="flex justify-content-between align-items-center">
              TK Main Email
            </div>
          </th>
          <th pSortableColumn="tkAutoApproval">
            <div class="flex justify-content-between align-items-center">
              Is Auto Approver
              <p-sortIcon field="tkAutoApproval"></p-sortIcon>
              <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
              type="text" field="tkAutoApproval" display="menu"></p-columnFilter>
            </div>
          </th>

        </tr>

      </ng-template>
      <ng-template pTemplate="body" let-users let-columns="columns">

        <tr>
          <td>
            <div class="flex align-items-center">
              <a class="btn btn-info btn-sm mr-2" pTooltip="View approver rule details" appActionTooltip (click)="viewUsers(users)"
                                    role="button"><i class="
                            mdi mdi-eye"></i></a>
              <button class="btn btn-warning btn-sm mr-2" pTooltip="Edit approver rule" appActionTooltip
                (click)="editUsers(users)"><i class="mdi mdi-pencil"></i></button>

              </div>
            </td>


            @for (col of columns; track col) {
              <td>
                {{users[col.field]}}
              </td>
            }

          </tr>

        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td  class="red-text" [attr.colspan]="4" style="padding: 1rem !important;">
              {{ gridErrorMessage?gridErrorMessage:"No records found"}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<p-dialog (onHide)="closeDialog()" [(visible)]="userDialog" [style]="{width: '80%'}" [header]="title" [modal]="true"
  styleClass="p-fluid" [resizable]="false" [draggable]="false">
  <ng-template pTemplate="content">
    <app-notification [errorMsg]="errorMsg"></app-notification>
    <form [formGroup]="userForm">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-xl-4">
              <div class="mb-1">
                <label for="mainEmail" class="form-label mb-1">Main Email</label>
                <input class="form-control p-2" readonly type="text" formControlName="mainEmail"
                  id="mainEmail">
              </div>
            </div>
            <div class="col-xl-4">
              <div class="mb-1">
                <label class="form-label">Approver Practice Area(s)</label>
                <p-multiSelect [maxSelectedLabels]="10000"  appendTo="body" defaultLabel="Select Approver Practice Area" formControlName="approverPracticeArea" [options]="practiceAreas" optionLabel="description" optionValue="description"></p-multiSelect>
              </div>
            </div>
            <div class="col-xl-4">
              <div class="mb-1">
                <label class="form-label">TK Users</label>
                <p-multiSelect [maxSelectedLabels]="10000" id="users" appendTo="body" defaultLabel="Select User"
                  formControlName="approveUsers" [style]="{'width':'100%'}"
                  [panelStyle]="{'width':'400px'}" [options]="tkusersList" optionLabel="mainEmail"
                optionValue="id"></p-multiSelect>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row mt-1">
            <div class="col-xl-12">
              <p-table [value]="approverList" [style]="{'width':'95%'}"
                styleClass="p-datatable-users" [rowHover]="true" responsiveLayout="scroll" [autoLayout]="true" [filterDelay]="0"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Existing TK Users</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-user>
                  <tr>
                    <td>{{user.mainEmail}}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td [attr.colspan]="4">
                      No records found
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
            <div class="col-xl-12 mt-4">
              <p-table [value]="approverPracticeAreaList" [style]="{'width':'95%'}"
                styleClass="p-datatable-users" [rowHover]="true" responsiveLayout="scroll"
                [autoLayout]="true" [filterDelay]="0"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Existing Approver Practice Areas</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-area>
                  <tr>
                    <td>{{area}}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td [attr.colspan]="4">
                      No records found
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>

      @if (!viewOnly) {
        <div class="row">
          <div class="col-xl-12">
            <div class="button-items" style="float: right;">
              <a class="btn btn-primary"  (click)="updateUserRoleMapping()" pTooltip="Save approver rule changes" appActionTooltip> Update @if (btnLoading) {
                <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
              }</a>
              <a class="btn btn-secondary" (click)="closeDialog()" pTooltip="Discard changes and close dialog" appActionTooltip> Cancel </a>
            </div>
          </div>
        </div>
      }
    </form>
  </ng-template>

</p-dialog>
